import axios from 'axios';
import qs from 'qs';
import sortBy from 'lodash/sortBy';
import Vue from 'vue';

export default {
  namespaced: true,
  state() {
    return {
      list: null,
      loaded: false,
      error: null,
      changes: false,
      answers_empty: false,
      enumerateLists: [],
      tiptap_changed: false
    };
  },

  mutations: {
    set_list(state, v) {
      state.list = v;
    },
    set_loaded(state, v) {
      state.loaded = v;
    },
    set_error(state, v) {
      state.error = v;
    },
    set_changes(state, v) {
      state.changes = v;
    },
    set_name(state, v) {
      state.list.name = v;
    },
    set_description(state, v) {
      state.list.description = v;
    },
    set_answers_empty(state, v) {
      state.answers_empty = v;
    },

    set_selected_type(state, data) {
      const { id, type } = data;
      const index = state.list.questions.findIndex(el => el.id === id);
      let quest = state.list.questions.find(el => el.id === id);

      quest.type = type;
      state.list.questions.splice(index, 1, quest);
    },

    set_required_status(state, data) {
      const { id, status } = data;
      const index = state.list.questions.findIndex(el => el.id === id);
      let quest = state.list.questions.find(el => el.id === id);

      quest.is_required = status;
      state.list.questions.splice(index, 1, quest);
    },

    add_question(state) {
      let ind = Math.floor(Math.random() * 1000) + 1;
      state.list.questions.push({
        name: '',
        is_new: true,
        id: Date.now(),
        type: 'single',
        description: `new_${ind}`,
        is_required: true,
        sort_order: state.list.questions.length + 1,
        configuration: {
          allow_multiply: false,
          allow_other: false,
          enumeration_id: null,
          dropout_answer_ids: []
        },
        answers: []
      });
    },

    update_questions(state, questions) {
      state.list.questions = questions;
    },

    set_desc(state) {
      state.list.questions.forEach((el, i) => (el.description = `new_${i}`));
    },

    delete_question(state, id) {
      const index = state.list.questions.findIndex(el => el.id === id);

      state.list.questions.splice(index, 1);
    },

    set_name_quest(state, data) {
      const { id, value } = data;
      const index = state.list.questions.findIndex(el => el.id === id);
      let quest = state.list.questions.find(el => el.id === id);

      quest.name = value;
      state.list.questions.splice(index, 1, quest);
    },

    add_answer(state, data) {
      let { id, value, cont, is_dropout } = data;
      const ind_quest = state.list.questions.findIndex(el => el.id === id); // находим индекс вопроса
      let question = state.list.questions.find(el => el.id === id); // находим сам вопрос
      let ind = question.answers.length;

      if (value === 'other') {
        question.answers.push({
          // добавляем вариант ответа "Другое"
          type: 'other',
          sort_order: ind + 1,
          content: cont
        });
      } else if (value === 'other-default') {
        question.answers.splice(ind - 1, 0, {
          // добавляем вариант ответа на предпоследнее место
          id: `new_${ind}`, //временный id
          type: question.type,
          sort_order: ind + 1,
          content: cont
        });
      } else {
        question.answers.push({
          // добавляем новый ответ
          id: `new_${ind}`, //временный id
          type: question.type,
          content: cont,
          sort_order: ind + 1,
          is_dropout
        });
      }
      state.list.questions.splice(ind_quest, 1, question); //вставляем новый вопрос
    },

    delete_answer(state, data) {
      const { id_quest, id_answer } = data;
      const ind_quest = state.list.questions.findIndex(el => el.id === id_quest); // находим индекс вопроса
      let question = state.list.questions.find(el => el.id === id_quest); // находим сам вопрос
      let ind_answ = question.answers.findIndex(el => el.id === id_answer); // находим индекс ответа

      question.answers.splice(ind_answ, 1); // удаляем ответ
      state.list.questions.splice(ind_quest, 1, question); //вставляем новый вопрос
    },

    set_answer(state, data) {
      const { question_id, answer_id, value } = data;
      const ind_quest = state.list.questions.findIndex(el => el.id === question_id); // находим индекс вопроса
      let question = state.list.questions.find(el => el.id === question_id); // находим сам вопрос
      let ind_answ = question.answers.findIndex(el => el.id === answer_id); // находим индекс ответа

      question.answers[ind_answ].content = value;
      state.list.questions.splice(ind_quest, 1, question); //вставляем новый вопрос
    },
    setCutOptioin(state, data) {
      const { question_id, answer_id, is_dropout } = data;
      const ind_quest = state.list.questions.findIndex(el => el.id === question_id); // находим индекс вопроса
      let question = state.list.questions.find(el => el.id === question_id); // находим сам вопрос
      let ind_answ = question.answers.findIndex(el => el.id === answer_id); // находим индекс ответа

      question.answers[ind_answ].is_dropout = is_dropout;
      state.list.questions.splice(ind_quest, 1, question); //вставляем новый вопрос
    },
    setDropoutDate(state, data) {
      const { question_id, is_dropout_date } = data;
      const ind_quest = state.list.questions.findIndex(el => el.id === question_id); // находим индекс вопроса
      let question = state.list.questions.find(el => el.id === question_id); // находим сам вопрос

      question.is_dropout_date = is_dropout_date;
      state.list.questions.splice(ind_quest, 1, question); //вставляем новый вопрос
    },
    setDropoutDateMin(state, data) {
      const { question_id, dropout_date_min } = data;
      const ind_quest = state.list.questions.findIndex(el => el.id === question_id); // находим индекс вопроса
      let question = state.list.questions.find(el => el.id === question_id); // находим сам вопрос

      question.dropout_date_min = dropout_date_min;
      state.list.questions.splice(ind_quest, 1, question); //вставляем новый вопрос
    },
    setDropoutDateMax(state, data) {
      const { question_id, dropout_date_max } = data;
      const ind_quest = state.list.questions.findIndex(el => el.id === question_id); // находим индекс вопроса
      let question = state.list.questions.find(el => el.id === question_id); // находим сам вопрос

      question.dropout_date_max = dropout_date_max;
      state.list.questions.splice(ind_quest, 1, question); //вставляем новый вопрос
    },
    changeDateValidMin(state, data) {
      const { question_id, isDateValid } = data;
      const ind_quest = state.list.questions.findIndex(el => el.id === question_id); // находим индекс вопроса
      let question = state.list.questions.find(el => el.id === question_id); // находим сам вопрос

      question.isDateValidMin = isDateValid;
      state.list.questions.splice(ind_quest, 1, question); //вставляем новый вопрос
    },
    changeDateValidMax(state, data) {
      const { question_id, isDateValid } = data;
      const ind_quest = state.list.questions.findIndex(el => el.id === question_id); // находим индекс вопроса
      let question = state.list.questions.find(el => el.id === question_id); // находим сам вопрос

      question.isDateValidMax = isDateValid;
      state.list.questions.splice(ind_quest, 1, question); //вставляем новый вопрос
    },
    setSelectedRange(state, data) {
      const { question_id, is_indicated_dates } = data;
      const ind_quest = state.list.questions.findIndex(el => el.id === question_id); // находим индекс вопроса
      let question = state.list.questions.find(el => el.id === question_id); // находим сам вопрос

      question.is_indicated_dates = is_indicated_dates;
      state.list.questions.splice(ind_quest, 1, question); //вставляем новый вопрос
    },

    SET_ENUMERATE_LISTS(state, payload) {
      state.enumerateLists = payload;
    },

    SET_APPLICATION_QUESTION_CONFIG_PROPERTY(state, { questionId, property, newValue }) {
      const questionIndex = state.list.questions.findIndex(x => x.id === questionId);

      if (questionIndex >= 0) {
        if (state.list.questions[questionIndex].configuration === null) {
          state.list.questions[questionIndex].configuration = {};
        }

        Vue.set(state.list.questions[questionIndex].configuration, property, newValue);
      }
    },

    TOGGLE_DROPOUT_ANSWER(state, { questionId, answerId }) {
      const questionIndex = state.list.questions.findIndex(x => x.id === questionId);

      if (questionIndex >= 0) {
        if (state.list.questions[questionIndex].configuration === null) {
          state.list.questions[questionIndex].configuration = {};
          Vue.set(state.list.questions[questionIndex].configuration, 'dropout_answer_ids', [answerId]);
        } else {
          if (state.list.questions[questionIndex].configuration.dropout_answer_ids === undefined) {
            Vue.set(state.list.questions[questionIndex].configuration, 'dropout_answer_ids', [answerId]);
          } else {
            const answerIndex = state.list.questions[questionIndex].configuration.dropout_answer_ids.findIndex(
              x => x === answerId
            );

            if (answerIndex >= 0) {
              state.list.questions[questionIndex].configuration.dropout_answer_ids.splice(answerIndex, 1);
            } else {
              state.list.questions[questionIndex].configuration.dropout_answer_ids.push(answerId);
            }
          }
        }
      }
    },

    CLEAR_DROPOUT_ANSWERS(state, { questionId }) {
      const questionIndex = state.list.questions.findIndex(x => x.id === questionId);

      if (questionIndex >= 0) {
        state.list.questions[questionIndex].configuration.dropout_answer_ids = [];
      }
    },

    CHANGED_TIPTAP(state, payload) {
      state.tiptap_changed = payload
    }
  },

  actions: {
    async load({ commit }, ids) {
      commit('set_loaded', true);
      commit('set_error', null);

      // Этап (имя и описание)
      let getStage = (await axios.get(`v3/vacancy-stages/survey/${ids.vacancy_id}`)).data;

      await axios
        .get(`v3/surveys/templates`, {
          params: { 'filter[vacancy_id]': ids.vacancy_id, with: ['questions', 'questions.answers'] },
          paramsSerializer: params => qs.stringify(params)
        })
        .catch(err => {
          commit('set_error', err);
          commit('set_loaded', false);
        })
        .then(response => {
          let questions = [];

          response.data._embedded.survey_templates[0]._embedded.questions.forEach(x => {
            const answers = [...x._embedded.answers];
            delete x._embedded;

            questions.push({ ...x, answers });
          });

          const application = {
            ...getStage, // Этап (имя и описание)
            ...response.data._embedded.survey_templates[0], // Шаблон
            questions // Вопросы
          };
          delete application._embedded;

          commit('set_list', application);
          commit('set_desc');
          commit('set_loaded', false);
        });
    },

    async update(context, survey) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);
      try {
        let stage = (
          await axios.patch(`v3/vacancy-stages/survey/${survey.vacancy_id}`, {
            name: survey.name,
            description: survey.description
          })
        ).data;
        let questions = (await axios.patch(`v3/surveys/templates/${survey.id}`, survey)).data;
        context.commit('set_list', Object.assign(stage, questions));
        context.commit('set_desc');
        context.commit('set_loaded', false);
      } catch (err) {
        console.log(err);
        context.commit('set_error', err);
        context.commit('set_loaded', false);
        return Promise.reject(err);
      }
    },

    async fetchEnumerateLists({ commit }, companyId) {
      await axios.get(`/v3/enumerations?filter[company_id]=${companyId}`).then(response => {
        commit('SET_ENUMERATE_LISTS', response.data._embedded.enumerations);
      });
    },

    clear({ commit }) {
      commit('set_list', null);
    }
  },
  getters: {
    list: state => state.list,
    name: state => (state.list && state.list.name ? state.list.name : ''),
    description: state => (state.list && state.list.description ? state.list.description : ''),
    loaded: state => state.loaded,
    error: state => state.error,
    has_changes: state => state.changes,
    answers_empty: state => state.answers_empty,

    isSomeListsEmpty: state => {
      // Ищем все вопросы с типом list и НЕ выбранным списком
      if (state.list !== null && state.list.questions.length > 0) {
        return state.list.questions.filter(x => x.type === 'list').some(x => x.configuration === null);
      } else {
        return false;
      }
    }
  }
};
